<template>
  <v-card class="mt-6">
    <v-card-title class="third white--text font-weight-bold">Agenda</v-card-title>
    <v-card-text>
      <div class="pa-4 d-flex justify-end">
        <div class="col-3">
          <v-select
            v-model="calendarFormat"
            item-value="value"
            item-text="label"
            dense
            outlined
            hide-details
            class="ma-2"
            label="type de calendrier"
            :items="filtersType"
          />
        </div>
      </div>
      <v-row>
        <v-col>
          <v-sheet height="580">
            <v-calendar
              ref="calendar"
              :value="selectedDate"
              color="third"
              first-time="08:00"
              interval-count="16"
              :interval-format="calendarTimeFormat"
              :type="calendarFormat"
              :events="plannerSessions"
              :weekdays="weekday"
              locale="fr"
              @click:more="changeCalendarFormat"
            />
          </v-sheet>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { computed, onBeforeMount, ref, watch } from '@vue/composition-api';
import getUnixTime from 'date-fns/fp/getUnixTime/index.js';
import { sessionsPerContentType, computeSessionStyle, frenchTime } from '../../helpers/utils';
import { getSessionFieldByWtype } from '../../helpers/sessions';

import store from '@/store';

export default {
  props: {
    contentType: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  setup (props) {
    // format calendar to 24h format
    const calendarTimeFormat = interval => interval.time;
    const calendarFormat = ref('week');
    const dailySessions = computed(() => store.getters.dailySessions);
    const weeklySessions = computed(() => store.state.sessions);
    const contentTypeSessions = computed(() => store.state.contentTypeAllSessions);
    const selectedDate = computed(() => store.getters.selectedDate);

    const filtersType = ref([
      { value: 'day', label: 'Jour' },
      { value: 'week', label: 'Semaine' }
    ]);

    // week start on monday instead of sunday
    const weekday = ref([1, 2, 3, 4, 5, 6, 0]);

    const prepareSessions = sessions => sessions.map(session => {
      const { sessionColor } = computeSessionStyle(session);
      const start = frenchTime(session.start_time * 1000, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
      const end = frenchTime(session.end_time * 1000, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
      return {
        name: `${session.name}`,
        start: getUnixTime(new Date(start)) * 1000,
        end: getUnixTime(new Date(end)) * 1000,
        color: sessionColor,
        timed: true
      };
    });

    const plannerSessions = ref([]);

    // change view day to date
    const changeCalendarFormat = () => {
      calendarFormat.value = 'day';
    };

    const getSessions = () => {
      const sessionField = getSessionFieldByWtype(props.contentType.wtype);
      switch (calendarFormat.value) {
        case 'day': {
          const contentTypeSessionsArray = sessionsPerContentType(props.contentType, sessionField, dailySessions.value);
          return prepareSessions(contentTypeSessionsArray);
        }
        case 'week': {
          const contentTypeWeeklySession = sessionsPerContentType(props.contentType, sessionField, weeklySessions.value);

          return prepareSessions(contentTypeWeeklySession || []);
        }

        default: {
          const contentTypeSessionsArray = sessionsPerContentType(props.contentType, sessionField, contentTypeSessions.value);
          return prepareSessions(contentTypeSessionsArray);
        }
      }
    };

    onBeforeMount(() => {
      plannerSessions.value = getSessions();
    });

    watch(calendarFormat, () => {
      plannerSessions.value = getSessions();
    });

    watch(contentTypeSessions, () => {
      plannerSessions.value = getSessions();
    });

    return { changeCalendarFormat, calendarTimeFormat, plannerSessions, calendarFormat, weekday, selectedDate, filtersType };
  }
};
</script>
